import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, FormSelect, FormInput } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import { Store } from "../flux";

const MainAreas = () => {

    const [ AreaData, SetAreaData ] = useState([]);
    const [ AppData, SetAppData ] = useState([]);

    useEffect(() => {

        const getData = async () => {

            const Areas = Store.getAreas();
            const Apps = Store.getApps();

            if (!Areas.length || !Apps.length) {

                await Store.retrieveAreas();
                await Store.retrieveApps();
                await SetAreaData(Store.getAreas());
                await SetAppData(Store.getApps());
            } else {

                SetAreaData(Store.getAreas());
                SetAppData(Store.getApps());
            }
        }

        getData();
    }, [ Store.getAreas() ]);

    const filterByApp = async (e) => {

        const AppName = e.target.value;

        await AreaData.filter((Area, Index) => {

            if (AppName !== "all") {

                if (Area.app_names.includes(AppName)) {

                    document.getElementById("area_row_" + Index).style.display = "";
                } else {

                    document.getElementById("area_row_" + Index).style.display = "none";
                }
            } else {

                document.getElementById("area_row_" + Index).style.display = "";
            }
        });
    }

    const filterByArea = async (e) => {

        const AreaName = e.target.value.toLowerCase();

        await AreaData.filter((Area, Index) => {

            if (AreaName !== "") {

                if (Area.name.toLowerCase().includes(AreaName)) {

                    document.getElementById("area_row_" + Index).style.display = "";
                } else {

                    document.getElementById("area_row_" + Index).style.display = "none";
                }
            } else {

                document.getElementById("area_row_" + Index).style.display = "";
            }
        });
    }

    const addArea = () => {

        alert("Contact Mobile admin.");
    }

    return (
        <Container fluid className="main-content-container px-4">
            {/* Page Header */}
            <Row noGutters className="page-header py-4">

                <Col className="col-3">
                    <PageTitle sm="4" title="View" subtitle="Areas" className="text-sm-left" />
                </Col>

                <Col className="col-2">
                    <FormInput placeholder="Search by area name..." id="filter_by_area_name" onChange={ (e) => filterByArea(e) } />
                </Col>

                <Col className="col-1"></Col>

                <Col className="col-2">
                    <FormSelect id="filter_by_app_name" onChange={ (e) => filterByApp(e) }>
                        <option value="all">Filter by App...</option>
                        { AppData.map((App, Index) => {

                            return <option key={ Index } value={ App.name }>{ App.name }</option>;
                        })}
                    </FormSelect>
                </Col>

                <Col className="col-2"></Col>

                <Col className="col-2">
                    <Button className="float-right" onClick={ addArea }>
                        <i className="material-icons">add</i>&nbsp;&nbsp;Add new Area
                    </Button>
                </Col>
            </Row>

            {/* Default Light Table */}
            <Row>
            <Col>
                <Card small className="mb-4">
                <CardHeader className="border-bottom">
                    <h6 className="m-0">Active Areas</h6>
                </CardHeader>
                <CardBody className="p-0 pb-3">
                    <table className="table mb-0">
                    <thead className="bg-light">
                        <tr>
                        {/* <th scope="col" className="border-0">
                            #
                        </th> */}
                        <th scope="col" className="border-0">
                            Name
                        </th>
                        <th scope="col" className="border-0">
                            Apps
                        </th>
                        <th scope="col" className="border-0">
                            NI Council
                        </th>

                        <th scope="col" className="border-0">

                        </th>
                        </tr>
                    </thead>
                    <tbody>

                        { AreaData.map((Area, Index) => {

                            return (
                                <tr key={ Index } id={ `area_row_${ Index }`}>
                                    {/* <td>{ Area.id }</td> */}
                                    <td>{ Area.name }</td>
                                    <td>{ Area.app_names }</td>
                                    <td><i style={{ fontSize: "1.2rem", color: Area.ni_council === "t" && "green" }} className="material-icons">{ Area.ni_council === "t" ? "done" : "clear" }</i></td>
                                    <td>
                                        <Link to={ { pathname: `/areas/${ Area.id }`, state: { AreaDetails: Area, Apps: AppData } }}>
                                            <Button className="btn-outline-primary">
                                                <i className="material-icons">edit</i>&nbsp;&nbsp;Edit
                                            </Button>
                                        </Link>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    </table>
                </CardBody>
                </Card>
            </Col>
            </Row>
        </Container>
    );
}

export default MainAreas;
